document.addEventListener('alpine:init', () => {
    Alpine.data('Footer', () => ({
        resourcesIsOpen: false,
        ourFirmIsOpen: false,
        rightMargin: '0px',
        setRightMargin() {
            const margin = (document.body.offsetWidth - this.$refs.quickLinksWrapper.offsetWidth) / 2;

            this.rightMargin = margin > 0 ? `${-margin}px` : '0px';
        },
        init() {
            this.setRightMargin();

            window.addEventListener('resize', () => {
                this.setRightMargin()
            });
        },
    }));
});
